import { createFileRoute } from "@tanstack/react-router"
import { teamSettingsMembersViewStaticData } from "src/views/TeamSettingsMembersView/constants"
import { TeamSettingsMembersView } from "src/views/TeamSettingsMembersView/TeamSettingsMembersView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/teams/$teamId/members")({
	component: TeamSettingsMembersView,
	staticData: teamSettingsMembersViewStaticData,
})
